<template>
    <div class="wrap">
        <LoadingProgress v-show="loading" :loadingValue="loadedAssets/neededAssets * 100"  />
        <DialogFrame id='dialog-logout-frame' ref='dialogLogout' :needClose='true' @emitConfirm='confirmLogout'>
            <div class="dialog-logout" slot='dialog-content'>
                <h6>Logout</h6>
                <div class="span-box">
                    <span>Come back soon!</span>
                    <span>Are you sure you want ot Log out? </span>
                </div>
            </div>
        </DialogFrame>

        <transition name="el-fade-in-linear">
            <div class="mask" v-show="extendMenu" @click="extendMenu=false"></div>
        </transition>
        
        <transition name="el-fade-in-linear">
            <div class="exhibition-intro" v-show="introToggle">
                <div class="pop-up-header">Introduction
                    <div class="close-btn" @click="introToggle=false">
                        <img src="@/assets/img/icon/crossW.svg" alt="" />
                    </div>
                </div>
                <div class="intro-content">
                    <div class="intro-p">
                        <p>{{introduction}}</p>
                    </div>
                    <div class="close-btn-spec" @click="introToggle=false">Close</div>
                </div>
            </div>
        </transition>
        <!-- 主要內容 -->
        <canvas id='indoor-scene'></canvas>

        <transition name="el-fade-in-linear">
            <div class="pop-up-tv" v-show="tvToggle">
                <div class="pop-up-header">{{tvName}}
                    <div class="close-btn" @click="closeTvPlayer">
                        <img src="@/assets/img/icon/crossW.svg" alt="" />
                    </div>
                </div>
                <div id="tv-screen"></div>
            </div>
        </transition>

        <div class="pop-up-scene" v-show="popUpCanvasToggle">
            <div class="pop-up-header">Model Name
            <div class="close-btn" @click="closePopScene">
                <img src="@/assets/img/icon/crossW.svg" alt="" />
            </div>
            </div>
            <canvas id='pop-up-canvas'></canvas>
            <div class="hint">
                <div class="img-box mouse">
                    <img src="@/assets/img/icon/mouse.svg" alt="" class="mouse">
                    <span>Left-click to rotate, right-click to move and scroll wheel to zoom the screen</span>
                </div>
               <div class="img-box cube">
                    <img src="@/assets/img/icon/uCube.svg" alt="">
                    <span>Click on cube can see the description</span>
                </div>
            </div>
        </div>

        <div class="pop-up-board" v-show="boardToggle">
            <div class="close-btn" @click="boardToggle=false; attachedWebsite='';">
                <img src="@/assets/img/icon/crossW.svg" alt="" />
            </div>
            <!--<el-image :src="attachedBoardImg" class='board-img' fit='cover'></el-image> -->
            <iframe id="myFrame" :src='attachedWebsite'  class='board-img' fit='cover' allow="camera *;microphone *"></iframe>
        </div>

        <div class="pop-up-formboard" v-show="formToggle"> 
            
            <div class="form-box">
                <div class="close-btn" @click="formToggle=false">
                <img src="@/assets/img/icon/crossW.svg" alt="" />
            </div>
                <div class="form-title">
                    <span>音樂自由之路：禁歌之王挑戰賽</span>
                </div>
                <div class="quiz-container">
                    <div v-for="(question, qIndex) in quizData" :key="qIndex" class="quiz-question">
                        <p><strong>{{ qIndex + 1 }}. {{ question.question }}</strong></p>
                        <div v-for="(option, oIndex) in question.options" :key="oIndex" class="quiz-option">
                            <label>
                                <input type="radio" :name="'question_' + qIndex" :value="oIndex" v-model="quizAnswers[qIndex]" required>
                                {{ option }}
                            </label>
                        </div>
                    </div>
                </div>
                
                <button v-if="!formIsAnswered" @click="submitQuiz" class="submit-btn">提交問卷</button>
                <button v-else @click="formToggle=false" disabled class="submit-btn">已答過題</button>
            </div>
        </div>

        <div class="pop-up-ranking" v-show="rankingToggle" >
            <div class="close-btn" @click="rankingToggle=false">
                <img src="@/assets/img/icon/crossW.svg" alt="" />
            </div>
            <div class="form-box">
                <div class="form-title">排行榜</div>
                <div class="ranking-list">
                    <!-- 新增欄位標題 -->
                    <div class="ranking-header">
                        <div class="ranking-rank">名次</div>
                        <div class="ranking-item-name">學習者名字</div>
                        <div class="ranking-item-score">學習積分</div>
                    </div>
                    <template v-for="(item, index) in rankingData">
                        <div class="ranking-item" :class="{'top1': index===0, 'top2': index===1, 'top3': index===2}">
                            <div class="ranking-rank">
                                <span class="rank-number">#{{ index + 1 }}</span>
                                <span class="rank-badge" v-if="index===0">🥇</span>
                                <span class="rank-badge" v-else-if="index===1">🥈</span>
                                <span class="rank-badge" v-else-if="index===2">🥉</span>
                            </div>
                            <div class="ranking-item-name">{{item.userName}}</div>
                            <div class="ranking-item-score">{{item.score}}</div>
                        </div>
                    </template>
                    <!-- 自己的分數 -->
                    <div class="ranking-item self-ranking-item">
                
                        <div class="ranking-item-name">我的名次：</div>
                        <div class="ranking-item-name-level">#{{ selfRanking }}</div>
                        <div class="ranking-item-score">{{ selfRankingData }}</div>
                    </div>
                    <div class="ranking-levelup" v-if="checkUserLevelUp">
                        <span>太棒了，恭喜你達成目標啦！趕快點擊下面的按鈕，讓你的 Avatar 煥然一新！</span>
                        <div class="ranking-levelup-btn">
                            <button @click="levelUp">升級</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="lobby-bar menu-bar">
            <div class="name-box pointer">
                <span v-if="playerID"><strong>{{playerID}}@{{exhibitionData.title}}</strong><br><span class="room-title">{{exhibitionData.roomName}}</span></span>
                <span v-if="!playerID"><strong>{{exhibitionData.title}}</strong><br><span class="room-title">{{exhibitionData.roomName}}</span></span>
                <img src="@/assets/img/icon/location.svg" alt="">
            </div>
            <div class="icon-box pointer" @click='extendMenu=!extendMenu;'>
                <img src="@/assets/img/icon/menu.svg" alt="">
                <span>More</span>
            </div>
            
            <!-- <div class="icon-box pointer" @click='backToEntrance'>
                <img src="@/assets/img/icon/logout.svg" alt="">
                <span>Exit</span>
            </div> -->
            <!-- extended menu slots start -->
            <div class="extended-menu exhibition" v-show="extendMenu" :class="{hasLogin: login}">

                <div class="icon-box pointer floater" @click='switchMenuState(MENU_STATE.BLOCK, false)'>
                    <span>Block Info</span>
                    <img src='@/assets/img/icon/block-v2.svg' alt="">
                    <img src='@/assets/img/icon/block-v2_active.svg' alt="">
                </div>
                <div class="icon-box pointer floater" @click='getRankingData()' v-if="isGameMode">
                    <span>Ranking</span>
                    <img src='@/assets/img/icon/block-v2.svg' alt="">
                    <img src='@/assets/img/icon/block-v2_active.svg' alt="">
                </div>
                <div class="icon-box pointer floater" @click='switchMenuState(MENU_STATE.PLAYER_ID, false)'>
                    <span>Player ID</span>
                    <img src='@/assets/img/icon/block-v2.svg' alt="">
                    <img src='@/assets/img/icon/block-v2_active.svg' alt="">
                </div>
                <!-- <div class="icon-box pointer floater" @click='shotPhoto'>
                    <span>Take Photo</span>
                    <img src='@/assets/img/icon/photo.png' alt="">
                    <img src='@/assets/img/icon/photo_active.png' alt="">
                </div> -->

                <div class="icon-box pointer floater" @click='switchMenuState(MENU_STATE.CHAT)'>
                    <span>Chat</span>
                    <img src='@/assets/img/icon/acc-info.png' alt="">
                    <img src='@/assets/img/icon/acc-info_active.png' alt="">
                </div>
                <!-- <div class="icon-box pointer floater" @click='logoutDialog'>
                    <span>{{login?'Logout':'Login'}}</span>
                    <img :src="login?require('@/assets/img/icon/logout.png'):require('@/assets/img/icon/login.svg')" alt="">
                    <img src="@/assets/img/icon/logout_active.png" alt="">
                </div> -->
            </div>
            <!-- extended menu slots end -->
            <transition name="el-fade-in-linear">
                <div class="main-menu" v-show="menuToggle&&!extendMenu">
                    <div class="title">{{menuTitle}}</div>
                    <!--  -->
                    <div class="block-item" v-show="menuState===MENU_STATE.BLOCK">
                        <div class="block-upper">
                            <img :src="exhibitionData.signboardUrl" alt="">
                            <div class="details">
                                <div class="name">{{exhibitionData.title}}</div>
                                <div class="theme"><img src="@/assets/img/icon/loc.svg" alt="">Theme - {{themeData.name}}</div>
                                <div><img src="@/assets/img/icon/email.svg" alt="">{{exhibitionData.email}}</div>
                                <div><img src="@/assets/img/icon/call.svg" alt="">{{exhibitionData.phone}}</div>
                            </div>
                        </div>
                        <div class="block-lower">{{exhibitionData.introduction}}</div>
                        <!-- <div class="btn-block">
                            <button class="pointer" @click='backToEntrance'>Exit Block</button>
                            <button class="pointer" @click='switchMenuState(MENU_STATE.CONTACT)'>Email
                                <img src="@/assets/img/icon/arr.svg" alt="">
                            </button>
                        </div> -->
                    </div>
                    <!--  -->
                    <div class="contact-item" v-show="menuState===MENU_STATE.CONTACT">
                        <div class="block-details">
                            <span class="name">{{exhibitionData.title}}</span>
                            <div class="contact-box">
                                <div class="email"><img src="@/assets/img/icon/email.svg" alt="">{{exhibitionData.email}}</div>
                                <div class="phone"><img src="@/assets/img/icon/call.svg" alt="">{{exhibitionData.phone}}</div>
                            </div>
                        </div>
                        <div class="name-form">
                            <div class="form-box">
                                <span>First name<span class='star'>*</span></span>
                                <input type="text" name="firstName" id="firstName" v-model="form.firstName" autocomplete="off">
                            </div>
                            <div class="form-box">
                                <span>Last name<span class='star'>*</span></span>
                                <input type="text" name="lastName" id="lastName" v-model="form.lastName" autocomplete="off">
                            </div>
                        </div>
                        <div class="email-box">
                            <span>Email<span class='star'>*</span></span>
                            <input type="email" name="email" id="email" v-model="form.email" autocomplete="off">
                        </div>
                        <div class="message-box">
                            <span>Message<span class='star'>*</span></span>
                            <textarea placeholder="type your message here2..." v-model="form.message" name="message" id="message"></textarea>
                        </div>
                        <div class="btn-block">
                            <button @click='switchMenuState(MENU_STATE.BLOCK)'>Cancel</button>
                            <button @click='sendMessage()'>Send!<img src="@/assets/img/icon/arr.svg" alt=""></button>
                        </div>
                        <transition name="el-fade-in-linear">
                            <div class="messages fail" v-show="showMessage===MESSAGE_STATE.FAIL">
                                <img src="@/assets/img/icon/fail.svg" alt="">
                                <span class="fail">Fail. {{login ? 'Please try again.' : 'Login required.'}}</span>
                            </div>
                        </transition>
                        <transition name="el-fade-in-linear">
                            <div class="messages success" v-show="showMessage===MESSAGE_STATE.SUCCESS">
                                <img src="@/assets/img/icon/success.svg" alt="">
                                <span class="success">Successfully sent!</span>
                            </div>
                        </transition>
                    </div>
                    <!--  -->
                    <div class="chat-item" v-show="menuState===MENU_STATE.CHAT">
                        <div class="chat-tags">
                            <div class="chats pointer" :class="{active:channel=='system'}" @click="channel='system'">System</div>
                            <div class="chats pointer" :class="{active:channel=='chat'}" @click="channel='chat'">Chat</div>
                            <div class="chats pointer" :class="{active:channel=='npc'}">NPC</div>
                        </div>
                        <div class="chat-box" v-show="channel=='npc'">
                            <div v-show="chatroomData.length" class="chat-container" v-for="item in chatroomData" :key="item.index" :class="{self:item.name===nickname}">
                                <div class="name">{{item.name}}</div>
                                <div class="messages">{{item.messages}}</div>
                                <div class="date">{{item.date}}</div>
                            </div>
                        </div>
                        <div class="chat-box" v-show="channel=='system'">
                            <div v-show="systemData.length" class="chat-container" v-for="item in systemData" :key="item.index">
                                <div class="name">{{item.name}}</div>
                                <div class="messages">{{item.messages}}</div>
                                <div class="date">{{item.date}}</div>
                            </div>
                        </div>
                        <div class="send">
                            <input type="text" name='chatMessage' v-model="chatMessage" placeholder="Say something..." autocomplete="off" v-on:keydown='keydownEvent'>
                            <img class='pointer' src="@/assets/img/icon/send.svg" alt="" @click="sendChatMessage">
                        </div>
                    </div>
                    <!--  -->
                    <div class="account-item" v-show="menuState===MENU_STATE.ACCOUNT_INFO">
                        <div class="edit-box">
                            <div class="info-box">
                                <span>Account ID</span>
                                <span>Saha12345678</span>
                            </div>
                            <div class="info-box">
                                <span>User Name</span>
                                <span>Saha</span>
                                <span>Edit</span>
                            </div>
                            <div class="info-box">
                                <span>Email</span>
                                <span>fake@gmail.com</span>
                                <span>Edit</span>
                            </div>
                            <div class="info-box">
                                <span>Password</span>
                                <span>************</span>
                                <span>Edit</span>
                            </div>
                        </div>
                    </div>
                    <!--  -->
                    <div class="account-item" v-show="false">
                        <div class="form-box">
                            <span>First name<span class='star'>*</span></span>
                            <input type="text" name="firstName" id="firstName" v-model="form.firstName" autocomplete="off">
                        </div>
                    </div>
                    <div class="playerid-item" v-show="menuState===MENU_STATE.PLAYER_ID">
                        <div class="block-upper">
                            <div class="playerid-item" v-show="menuState===MENU_STATE.PLAYER_ID">
                                <div class="block-upper">
                                    <div class="form-box">
                                        <span>Player ID<span class='star'>*</span></span>
                                        <input type="text" name="playerID" id="playerID" v-model="playerID" autocomplete="off">
                                    </div>
                                </div>
                            </div>
                            
                        </div>
                     
                    </div>
                    <img src="@/assets/img/icon/close.svg" alt="" class="close pointer" @click='menuToggle=false'>
                </div>
            </transition>
           
        </div>



    </div>
</template>

<style lang='scss'>
@import '@/assets/scss/exhibition.scss';

.ranking-item {
    display: flex;
    align-items: center;
    padding: 12px 20px;
    background: rgba(255, 255, 255, 0.9);
    margin-bottom: 8px;
    border-radius: 8px;
    transition: all 0.3s ease;
    font-size: 1.1em;
    border: 1.5px solid #e0e0e0;
    
    &:hover {
        transform: translateX(5px);
        box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
        background: #f5faff;
    }

    .ranking-rank {
        width: 56px;
        text-align: center;
        font-weight: bold;
        font-size: 1.2em;
        .rank-badge {
            font-size: 1.6em;
        }
    }

    .ranking-item-name {
        flex: 1;
        padding: 0 15px;
        font-size: 1.1em;
        color: #333;
        word-break: break-all;
    }

    .ranking-item-score {
        font-weight: bold;
        color: #2196F3;
        font-size: 1.2em;
        min-width: 80px;
        text-align: right;
    }
}

// 前三名特殊樣式
.ranking-item.top1 {
    background: linear-gradient(to right, #fffbe6 60%, #fff 100%);
    border: 2px solid #FFD700;
}
.ranking-item.top2 {
    background: linear-gradient(to right, #f0f4f8 60%, #fff 100%);
    border: 2px solid #C0C0C0;
}
.ranking-item.top3 {
    background: linear-gradient(to right, #fbeee6 60%, #fff 100%);
    border: 2px solid #CD7F32;
}

.pop-up-ranking{
    
    border-radius: 20px;
    // 只用漸層，不用背景圖
    background: linear-gradient(135deg, rgba(255,255,255,0.92) 60%, rgba(173,216,230,0.55) 100%);
    box-shadow: 0 8px 32px 0 rgba(31, 38, 135, 0.18), 0 0 0 4px rgba(173,216,230,0.12);
    padding: 24px 32px 32px 32px;
    min-width: 350px;
    // 玻璃毛玻璃效果
    backdrop-filter: blur(8px) saturate(1.2);
    -webkit-backdrop-filter: blur(8px) saturate(1.2);
    border: 2.5px solid rgba(255,255,255,0.35);

    .close-btn {
        position: absolute;
        top: -30px;
        right: -25px;
        width: 50px;
        height: 50px;
        border-radius: 50%;
        line-height: 47px;
        color: #fff;
        overflow: hidden;
        cursor: pointer;
        z-index: 6;
        background-color: gray;
    }
    .self-ranking-item{
        background: linear-gradient(to right, #add8e6 60%, #fff 100%);
        justify-content: space-between;
        .ranking-item-name,
        .ranking-item-name-level,
        .ranking-item-score{
            flex-grow: 1;
        }
    }
    .form-box {
        overflow: hidden;
        background: transparent;
        box-shadow: none;
        padding: 3% 0%;
        width: 100%;
        .form-title {
            font-size: 1.6em;
            font-weight: bold;
            color: #2196F3;
            text-align: center;
            margin-bottom: 18px;
            letter-spacing: 2px;
            text-shadow: 0 2px 8px #fff, 0 1px 0 #b3e0ff;
        }
        .ranking-list {
            height: 100%;
            position: relative;
            overflow-y: auto;
            padding-right: 8px;
        }
    }
    .ranking-levelup{
        color: #333;
        font-size: 1.2em;
        font-weight: bold;
        text-align: center;
        margin-top: 20px;
        margin-bottom: 20px;
        padding: 20px;
        background: linear-gradient(135deg, rgba(255,255,255,0.95) 0%, rgba(255,255,255,0.8) 100%);
        border-radius: 15px;
        box-shadow: 0 8px 32px rgba(31, 38, 135, 0.15);
        backdrop-filter: blur(4px);
        border: 1px solid rgba(255, 255, 255, 0.18);
        
        span {
            display: block;
            margin-bottom: 15px;
            color: #2196F3;
            text-shadow: 0 2px 4px rgba(0,0,0,0.1);
        }
        
        button {
            background: linear-gradient(45deg, #2196F3, #00BCD4);
            color: white;
            border: none;
            padding: 12px 30px;
            font-size: 1.1em;
            font-weight: bold;
            border-radius: 25px;
            cursor: pointer;
            transition: all 0.3s ease;
            box-shadow: 0 4px 15px rgba(33, 150, 243, 0.3);
            text-transform: uppercase;
            letter-spacing: 1px;
            
            &:hover {
                transform: translateY(-2px);
                box-shadow: 0 6px 20px rgba(33, 150, 243, 0.4);
                background: linear-gradient(45deg, #1E88E5, #00ACC1);
            }
            
            &:active {
                transform: translateY(1px);
                box-shadow: 0 2px 10px rgba(33, 150, 243, 0.3);
            }
            
            &::after {
                content: '';
                position: absolute;
                top: -2px;
                left: -2px;
                right: -2px;
                bottom: -2px;
                background: linear-gradient(45deg, #2196F3, #00BCD4);
                border-radius: 26px;
                z-index: -1;
                opacity: 0;
                transition: opacity 0.3s ease;
            }
            
            &:hover::after {
                opacity: 1;
            }
        }
    }
}

// 問卷樣式
.pop-up-formboard {
    position: fixed;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 90%;
    max-width: 1000px;
    background: #f0f0e0; // 米色背景
    border: 3px solid #8FBC8F; // 綠色邊框
    border-radius: 15px;
    box-shadow: 0 5px 15px rgba(0, 0, 0, 0.2);
    z-index: 1001;
    display: flex;
    flex-direction: column;
    max-height: 80vh;

    .close-btn {
        position: absolute;
        top: 10px;
        right: 10px;
        cursor: pointer;
        img {
            width: 20px;
            height: 20px;
        }
    }

    .form-box {
        padding: 0;
        flex-grow: 1; // 允許內容區域增長
        overflow-y: auto; // 內容過多時滾動
        border-radius: 0 0 12px 12px; // 底部圓角

        .form-title {
            position: absolute;
            width: 100%;
            background-color: #55a655; // 綠色背景
            color: white;
            padding: 15px 20px;
            text-align: center;
            font-size: 1.4em;
            font-weight: bold;
            border-radius: 12px 12px 0 0; // 頂部圓角
        }

        .quiz-container {
            padding-top: 20px;
    
        }
        .quiz-question {
            padding: 20px;
            border-bottom: 2px dashed #add8e6; // 藍色虛線分隔
            background-color: #fff; // 白色背景

            &:last-child {
                border-bottom: none;
            }

            p {
                margin-bottom: 15px;
                font-size: 1.1em;
                strong {
                    font-size: 1.3em; // 放大題號
                    font-style: italic;
                    margin-right: 5px;
                    color: #4682B4; // 鋼藍色題號
                }
            }
        }

        .quiz-option {
            margin-bottom: 10px;
            label {
                display: flex;
                align-items: center;
                cursor: pointer;
                font-size: 1em;
                color: #333;
                input[type="radio"] {
                    margin-right: 10px;
                    accent-color: #55a655; // 設置選中顏色為綠色
                }
            }
        }

        .submit-btn {
            display: block;
            margin: 20px auto;
            padding: 10px 30px;
            background-color: #d3d3d3; // 灰色背景
            border: 2px solid #a9a9a9; // 深灰色邊框
            border-radius: 8px;
            color: #333;
            font-size: 1.1em;
            font-weight: bold;
            cursor: pointer;
            transition: background-color 0.3s, border-color 0.3s;

            &:hover {
                background-color: #c0c0c0;
                border-color: #808080;
            }
        }
    }
}


.ranking-header {
    display: flex;
    align-items: center;
    padding: 12px 20px;
    background: rgba(33, 150, 243, 0.1);
    margin-bottom: 12px;
    border-radius: 8px;
    font-weight: bold;
    color: #2196F3;
    font-size: 1.1em;
    border: 1.5px solid rgba(33, 150, 243, 0.2);

    .ranking-rank {
        width: 56px;
        text-align: center;
    }

    .ranking-item-name {
        flex: 1;
        padding: 0 15px;
    }

    .ranking-item-score {
        min-width: 80px;
        text-align: right;
    }
}

</style>

<script>

import LoadingProgress from "@/components/LoadingProgress";
import DialogFrame from "@/components/DialogFrame.vue";
import * as Babylon from '@babylonjs/core';
import * as BabylonGUI from '@babylonjs/gui';
import * as utils from "@/utils/main.js";
import * as Ammo from "ammo.js";
// import * as cannon from "cannon";
import "@babylonjs/loaders";//Load External Assets.
import { Inspector } from '@babylonjs/inspector';
import {getSellerExhibition, HostUrl, sendMail, getUserAccByAdmin, exhInteract, checkTicket, exhEXP, getRanking, sendEvent, sendFormResult, getFormResult, getSelfRanking, getVenderProfile} from '@/api';
import axios from "axios";
import quiz from "@/assets/data/quiz.json";
import {mapGetters,mapActions} from "vuex";
import { MeshoptCompression } from "@babylonjs/core/Meshes/Compression";
MeshoptCompression.Configuration = { decoder: { url: "/decoders/meshopt_decoder.js" } };

export default {
    components:{
        LoadingProgress, DialogFrame
    },
    data(){
        return{
            //環境資料
            hostUrl: HostUrl,
            baseURL: process.env.BASE_URL,
            loading: true,
            extendMenu: false,
            introToggle: false,
            introduction:'',
            tvToggle: false,
            tvName: '',
            tvUrl: '',
            scene: null,
            canvas: null,
            camera: null,
            engine: null,
            RID: null,
            roomId: null,
            uid: null,
            bgc: null,
            loadedAssets: 0,
            neededAssets: 99,
            exhibitionData: {},
            themeData: {},
            showGround: false,
            groundScale: 1,
            default_exhibition_data : {
                address: '',
                email: '',
                link: '',
                phone: '',
                signboardUrl: '',
                title: '',
                introduction:'',
                roomName: '',
            },
            default_theme_data : {
                description: '',
                key: '',
                name: '',
            },
            meshData: [],
            keyInputs: {},
            characterDestination: {
                distance:0,
                target:null,
            },
            teleportMesh: [],
            teleportTypeName: [],
            collisionTypeName: [],
            toggleList: [],
            isGameMode: false,
            debugMode: false,
            //介面
            popUpCanvasToggle: false,
            boardToggle: false,

            //介面資料
            attachedWebsite: '',
            showMessage: 0,
            menuToggle: false,
            menuState: 0,
            channel:"chat",
            chatMessage: '',
            form: {
                firstName:'',
                lastName:'',
                email:'',
                message:'',
            },
            chatroomData: [],
            MENU_STATE: Object.freeze({
                'INTRO': 0,
                'CHAT': 1,
                'CONTACT': 2,
                'ACCOUNT_INFO': 3,
                'PLAYER_ID': 4,
            }),
            MESSAGE_STATE: Object.freeze({
                'FAIL': 1,
                'SUCCESS': 2,
                'WARN': 3,
            }),
            systemData:[],
            playerID:null,
            attachedBoardImg: null,
            player: null,
            viewStartTime: null,
            formToggle: false, //問卷
            rankingToggle: false, //排行榜
            rankingData: [],
            selfRankingData: null,
            selfRanking: null,
            oldSelfRankingData: null,
            quizData: quiz, // 加入問卷資料
            quizAnswers: {}, // 初始化答案物件
            formIsAnswered: false, //是否已經答過題
            checkUserLevelUp: false, //是否已經升級
            videoWatchTimer: null,
            videoWatchedSecondsSet: new Set(),
            videoIsPlaying: false,
            videoCurrentTime: 0,
            watchedSeconds: new Set(),
            videoWatchInterval: null,
            getWatchedSeconds: () => 0,
            levelLimit: 400,
        }
    },
    watch:{
        playerID(newPlayerID) {
            window.localStorage.setItem('playerID', newPlayerID);
        }
    },
    methods:{
        ...mapActions(['setLogout']),
        async init(){
            
 
            this.RID = this.$route.query.id;
            this.roomId = this.$route.query.room;
            
            // 取得資料
            await this.getMeshData(this.roomId,this.RID);
        

            //整理引擎
            await this.setEngine()
            //整理場景
            await this.setScene();
 
            //整理物件
            //await this.setMeshes(this.meshData);

            await this.loadPlayground();

            
            //建立環境
            await this.setEnvMap(this.bgc);

            //建立角色
            await this.setCharacter();

            //建立事件
            await this.taggleEvent();
            
            if(this.debugMode){
                Inspector.Show(this.scene, {
                    embedMode: true
                });
            }
        },
        
       
        async setEngine(){
            console.log('setEngine');
            this.canvas = document.getElementById('indoor-scene');
            this.engine = await new Babylon.Engine(this.canvas, true, {preserveDrawingBuffer: true, stencil: true }, true);
            this.engine.enableOfflineSupport = false;
            Babylon.Database.IDBStorageEnabled = false;
            this.engine.disableManifestCheck = false;
            this.loadingScreen = new utils.CustomLoadingScreen();
            this.engine.loadingScreen = this.loadingScreen;//disable babylon's default loading effect
            this.engine.runRenderLoop(()=>{
                this.scene.render();
                this.engine.resize();
            })
        },
        async setCamera(){
            console.log('setCamera');
            // this.camera = new Babylon.ArcRotateCamera('playerCamera',-(Math.PI/2), Math.PI/3, 50, this?.character||new Babylon.Vector3.Zero(),scene, true);
            this.camera = new Babylon.ArcRotateCamera("playerCamera", 3 * Math.PI / 2, Math.PI / 3, 30, new Babylon.Vector3(0, 3, 0), this.scene);
            this.camera.lowerRadiusLimit = 1;
            this.camera.upperRadiusLimit = 8;
            this.camera.minZ = .10;
            this.camera.radius = 100;
            this.camera.checkCollisions = false;
            this.camera.attachControl(this.canvas,true);
            this.camera.maxCameraSpeed = 10
            this.camera.inputs.removeByType("ArcRotateCameraKeyboardMoveInput");
            this.camera.radius = this.camera.radius * 1 ;

            window.camera = this.camera;
        },
        async setScene(){
            console.log('setScene');
            
            this.scene = new Babylon.Scene(this.engine);
            //定相機
            await this.setCamera();

            await this.setBasicMeshes();
            await this.setBasicMaterial();
            await this.setLightAndShadows();
            //啟動物理
            const ammoModule = await new Ammo();
            this.scene.enablePhysics(new Babylon.Vector3(0, -9.81, 0), new Babylon.AmmoJSPlugin(true, ammoModule)); 
            //this.scene.enablePhysics(new Babylon.Vector3(0, -9.81, 0), new Babylon.CannonJSPlugin(true, 8, cannon));


            const gravity = new Babylon.Vector3(0, -9.81, 0);
            this.scene.gravity = gravity;
            this.scene.collisionsEnabled = true;
            this.scene.workerCollisions = true;

            //最佳化
            this.scene.setRenderingAutoClearDepthStencil(this.scene,
                true,  // autoClear：整組都不自動清
                true,  // depth：不清深度
                false); // stencil：不清模版


            //整理物件
            await this.setMeshes(this.meshData);
            
            this.hl = new Babylon.HighlightLayer("hl1", this.scene);
            console.log('highlightLayer:',this.hl);
            this.scene.registerBeforeRender(()=>{
                if(this.loadedAssets === this.neededAssets){
                    this.loading = false;
                }
                //this.cameraRadius = this.camera.radius;
                if(this.renderFrames<30){
                    this.renderFrames++;
                }else{
                    this.scene.renderTargetsEnabled = false;
                }
            
            });
            this.scene.actionManager = new Babylon.ActionManager(this.scene);
            this.keyInputs = {}; // Initialize keyInputs as an empty object
            this.scene.actionManager.registerAction(new Babylon.ExecuteCodeAction(Babylon.ActionManager.OnKeyDownTrigger, (evt) => {
                this.keyInputs[evt.sourceEvent.key] = evt.sourceEvent.type == "keydown";
            }));
            this.scene.actionManager.registerAction(new Babylon.ExecuteCodeAction(Babylon.ActionManager.OnKeyUpTrigger, (evt) => {
                this.keyInputs[evt.sourceEvent.key] = evt.sourceEvent.type == "keydown";
            }));
            this.scene.onPointerObservable.add((pointerInfo)=>{
                if(pointerInfo.type===Babylon.PointerEventTypes.POINTERTAP){
                    if(!pointerInfo) return;
                    this.interactWithMesh(pointerInfo?.pickInfo?.pickedMesh||null);
                }
            });

            let helper = this.scene.createDefaultEnvironment({
                skyboxSize: 50,
                createSkybox: false,
                createGround: false,
                cameraExposure: 1,
                cameraContrast: 1.5,    
            });
            
            window.scene = this.scene;
            
        },

        async setBasicMeshes(){
            console.log("setBasicMeshes");
            await new Promise((resolve, reject) => {
                Babylon.SceneLoader.ImportMesh("", this.baseURL + 'static/models/component/model/', 'Geo.glb', this.scene, (container) => {
                    console.log("ImportMesh Geo Done");
                    container.forEach((e, index) => {
                        e.setEnabled(false);
                    });
                    resolve();
                });
            });
           
        },
        async setBasicMaterial(){
            this.basicMaterials = [];
            console.log('setBasicMaterial');
            await new Promise((resolve, reject) => {
                Babylon.SceneLoader.ImportMesh('', this.baseURL+'static/models/material/', 'Material.glb', this.scene, (container)=>{
                    console.log("ImportMaterial Done");
                    for(let i=0;i<container.length;i++){
                        let materialName = container[i].name;
                        if(materialName.includes("Concrete")||materialName.includes("Floor")||materialName=='Grass-1'||materialName.includes("Metal")||materialName=='Plastic-1'||materialName.includes('Wood')||materialName.includes('Marble')||materialName=='Leather-1'){
                            if(container[i].material){
                                this.basicMaterials.push(container[i].material);
                                container[i].setEnabled(false);
                            }
                        }
                    }
                    resolve();
                });
            });
        },
        //新取資料
        async getMeshData(roomId,RID){ 
            console.log('getMeshData');
            const res = await getSellerExhibition({}, RID);
            const sceneUrl = res.data.data.rooms[roomId-1].sceneUrl

            this.exhibitionData = res?.data?.data?.sellerProfile || default_exhibition_data;
            
            this.themeData = res?.data?.data?.theme || default_theme_data;
            this.exhibitionData.signboardUrl = res?.data?.data?.signboardUrl || '';
            this.exhibitionData.title = res?.data?.data?.title || '';
            this.exhibitionData.roomName = res?.data?.data?.rooms[roomId-1].name || '';
            this.exhibitionData.introduction = res?.data?.data?.introduction || '';
            
            try {
                const res = await axios.get(sceneUrl, {
                    transformRequest: (data, headers) => {
                        delete headers.common['Authorization'];
                    }

                });
                console.log(res.data);
                if(res.data.isGameMode){
                    this.isGameMode = true;
                    if (localStorage.getItem("token") === null){
                        // 保存當前頁面資訊
                        const currentPath = this.$route.fullPath;
                        const currentQuery = this.$route.query;
                        
                        // 構建跳轉 URL
                        const redirectUrl = `/landing?${new URLSearchParams({
                            ...currentQuery,
                            redirect: currentPath
                        }).toString()}`;
                        
                        // 強制同步跳轉
                        window.location.href = redirectUrl;                        
                        return; // 確保在跳轉後立即返回，不執行後續程式碼
                    }
                    
                    // 只有在有 token 的情況下才執行以下程式碼
                    const userId = localStorage.getItem('userId')
                    const selfResponse = await getSelfRanking(userId);
                    console.log('selfResponse',selfResponse);
                    this.selfRankingData = selfResponse.data.data;
                    this.oldSelfRankingData = selfResponse.data.data;
                    console.log('selfRankingData',this.selfRankingData);
                }
                if(res.data.debugMode){
                    this.debugMode = true;
                    console.log('debugMode:',this.debugMode);
                }

                let mesh = res.data.meshData;
                if(res.data.showGround){
                    this.showGround = res.data.showGround;
                }

                if(res.data.groundScale){
                    this.groundScale = res.data.groundScale;
                }
                this.meshData = res.data.meshData;
                
                this.neededAssets = mesh.length;
                this.bgc = res.data.bgc
                console.log('getSellerExhibitions:'+this.loadedAssets + ' / ' + this.neededAssets);
                

            } catch (error) {
                if (error.response) {
                    console.log(error);
                    //this.backToEntrance();
                }
            }
        },

        async setMeshes(meshData){
            console.log('setMeshes');
            meshData.forEach(async(e,index)=>{ //看mesh裡面有什麼
                if(index+1 == meshData.length)this.$store.dispatch('loader/hide');
                if (e.type === 'cus') {
                    console.log('custom:' , e);
                    Babylon.SceneLoader.ImportMesh('', this.hostUrl+e.url,e.fileName,this.scene,(container)=>{
                        let thisMesh = container.filter(e=>e.name===('__root__'))[0];
                        thisMesh.rotationQuaternion = null;
                        thisMesh.position.y = e.position.y;
                        thisMesh.position.x = e.position.x;
                        thisMesh.position.z = e.position.z;
                        thisMesh.rotation.y = e.rotation.y;
                        thisMesh.rotation.x = e.rotation.x;
                        thisMesh.rotation.z = e.rotation.z;
                        thisMesh.scaling.y = e.scaling.y;
                        thisMesh.scaling.x = e.scaling.x*-1;
                        thisMesh.scaling.z = e.scaling.z;
                        if(thisMesh.groupParent){
                            thisMesh.position.x = thisMesh.position.x + thisMesh.groupParent[0].position.x;
                            thisMesh.position.y = thisMesh.position.y + thisMesh.groupParent[0].position.y;
                            thisMesh.position.z = thisMesh.position.z + thisMesh.groupParent[0].position.z;
                        }


                        //最佳化
                        thisMesh.freezeWorldMatrix();
                        //thisMesh.checkCollisions = true;

                        //建立顯示板
                        var advancedTexture = BabylonGUI.AdvancedDynamicTexture.CreateFullscreenUI("UI");

                        var rect1 = new BabylonGUI.Rectangle();
                        rect1.width = 0.1;
                        rect1.height = "150px";
                        rect1.cornerRadius = 10;
                        rect1.color = "Orange";
                        rect1.thickness = 2;
                        rect1.background = "white";
                        advancedTexture.addControl(rect1);

                        var label = new BabylonGUI.TextBlock();
                        label.text = e.senseSetting.senseInforText;
                        rect1.addControl(label);

                        rect1.linkWithMesh(thisMesh); 
                        rect1.linkOffsetY = -500;
                        rect1.isVisible = false;

                        
                        //建立觸發器
                        if(e.senseSetting.senseScaleX > 0 && e.senseSetting.senseScaleY > 0){
                            const height = 10;
                            const width = 10;
                            const toggleArea = Babylon.MeshBuilder.CreatePlane("toggleArea_" + e.parentName, { width: width ,height: height}, this.scene);
                            toggleArea.rotation.x = Math.PI / 2;
                            toggleArea.scaling.x = parseFloat(e.senseSetting.senseScaleX).toFixed(2),
                            toggleArea.scaling.y = parseFloat(e.senseSetting.senseScaleY).toFixed(2),
                            toggleArea.position.y = 0.5
                            toggleArea.visibility = 0.1;
                            toggleArea.parent = thisMesh;
                            this.toggleList.push("toggleArea_" + e.parentName);
                        }

                        
                        //註冊可觸發物件範圍
                        let toggleOnAction = new Babylon.ExecuteCodeAction(
                            {
                                trigger: Babylon.ActionManager.OnIntersectionEnterTrigger,
                                parameter: toggleArea,
                            },
                            (evt) => {
                                console.log('toggle on!');
                                container[1].renderOutline = true;
                                container[1].outlineColor = new Babylon.Color3(0, 1, 0);
                                container[1].outlineWidth = 0.05;
                                rect1.isVisible = true;
                            }
                        );
                        let toggleOffAction = new Babylon.ExecuteCodeAction(
                            {
                                trigger: Babylon.ActionManager.OnIntersectionExitTrigger,
                                parameter: toggleArea,
                            },
                            (evt) => {
                                console.log('toggle off!');
                                container[1].renderOutline = false;
                                rect1.isVisible = false;
                            }
                        );
                        this.character.actionManager.registerAction(toggleOnAction);
                        this.character.actionManager.registerAction(toggleOffAction);
               
                        console.log('model done')

                        

                        this.loadedAssets++;
                        container.forEach(ele=>{
                            this.shadowGenerator.getShadowMap().renderList.push(ele);
                            this.shadowGenerator.addShadowCaster(ele);
                            ele.url = e.url;
                        })
                    },null,(error)=>{
                        this.loadedAssets++;
                    });
                } else if (e.type === 'notGeo') {
                    console.log('notGeo',e);
                    if(e.modelType === 'Teleport'){
                        this.loadedAssets++;
                        return;
                    }
                    if(e.modelType === 'Collision'){
                        this.loadedAssets++;
                        return;
                    }
                    if(e.modelType === 'Form' && !this.isGameMode){
                        this.loadedAssets++;
                        return;
                    }
                    Babylon.SceneLoader.ImportMesh('', e.url, e.fileName, this.scene, (container) => {
                        console.log('importMesh done',container);
                        const rootMesh = container.find(e => e.name === '__root__');
                        const imgMesh = container.find(e => e.name.includes('UploadHere'));
                        const colorMeshs = container.filter(e => e.name.includes('Color') || e.name.includes('color'));
                        if (imgMesh && e.imgMaterial) {
                            const imgMat = new Babylon.StandardMaterial('', this.scene);
                            imgMat.diffuseTexture = new Babylon.Texture(e.imgMaterial, this.scene);
                            imgMat.emissiveTexture = new Babylon.Texture(e.imgMaterial, this.scene);
                            imgMat.diffuseTexture.vScale = -1;
                            imgMat.emissiveTexture.vScale = -1;
                            imgMesh.material = imgMat;
                        }
                        if (colorMeshs.length > 0) {
                            colorMeshs.forEach(item => {
                                item.material = this.basicMaterials[e.outputMaterial];
                            });
                        } else {
                            const colorMat = new Babylon.StandardMaterial('', this.scene);
                            colorMat.diffuseColor = Babylon.Color3.FromHexString(e.color);
                            colorMeshs.forEach(item => {
                                item.material = colorMat;
                            });
                        }
                        //最佳化
                        // rootMesh.freezeWorldMatrix();
                        // rootMesh.material.freeze();
                        rootMesh.rotationQuaternion = null;
                        rootMesh.position = new Babylon.Vector3(e.position.x, e.position.y, e.position.z);
                        
                        rootMesh.rotationQuaternion = Babylon.Quaternion.RotationYawPitchRoll(e.rotation.y, e.rotation.x, e.rotation.z);
              
                        rootMesh.scaling = new Babylon.Vector3(e.scaling.x * -1, e.scaling.y, e.scaling.z);
                        this.loadedAssets++;
                        container.forEach(ele => {
                            if (ele) {
                                ele.videoLink = e.videoLink;
                                ele.boardImg = e.imgMaterial;
                                ele.website = e.website;
                                this.shadowGenerator.getShadowMap().renderList.push(ele);
                                this.shadowGenerator.addShadowCaster(ele);
                            }
                        });

                        console.log('imgMesh',imgMesh);
                        if(e.modelType === 'Form'){
                            container.forEach(item => {
                                item.name = item.name.replace('Board','Form');
                            });
                        
                        }

                        // //建立觸發器
                        // const radius = 5;
                        // const toggleArea = Babylon.MeshBuilder.CreateDisc("toggleArea_" + e.parentName, { radius: radius }, this.scene);
                        // toggleArea.rotation.x = Math.PI / 2;
                        // toggleArea.scaling.x = e.scaling.x;
                        // toggleArea.scaling.z = e.scaling.z;
                        // toggleArea.position.y = 0.5
                        // toggleArea.visibility = 0.1;
                        // toggleArea.parent = rootMesh;
                        // this.toggleList.push("toggleArea_" + e.parentName);

                        if(e.modelType === 'Board'){
                            if(e.senseSetting.senseScaleX > 0 && e.senseSetting.senseScaleY > 0){
                                const height = 10;
                                const width = 10;
                                const toggleArea = Babylon.MeshBuilder.CreatePlane("toggleArea_" + e.parentName, { width: width ,height: height}, this.scene);
                                toggleArea.rotation.x = Math.PI / 2;
                                toggleArea.scaling.x = parseFloat(e.senseSetting.senseScaleX).toFixed(2),
                                toggleArea.scaling.y = parseFloat(e.senseSetting.senseScaleY).toFixed(2),
                                toggleArea.position.y = 0.5
                                toggleArea.visibility = 0.1;
                                toggleArea.parent = rootMesh;
                                this.toggleList.push("toggleArea_" + e.parentName);  // 修改這行，加上 parentName
                            }

                        }   

                        

                    }, null, (error) => {
                        this.loadedAssets++;
                    });
                } else if (e.type === 'Geo') {
                    console.log('Geo',e);
                    const container = new Babylon.Mesh(e.parentName, this.scene);
                    const cloneMesh = this.scene.getMeshByName(e.childName).clone();
                    cloneMesh.name = e.parentName;
                    cloneMesh.setEnabled(true);
                    cloneMesh.receiveShadows = true;
                    if (e.color) {
                        const colorMat = new Babylon.StandardMaterial('', this.scene);
                        colorMat.diffuseColor = Babylon.Color3.FromHexString(e.color);
                        cloneMesh.material = colorMat;
                    } else {
                        cloneMesh.material = this.basicMaterials[e.outputMaterial];
                    }
                    this.shadowGenerator.getShadowMap().renderList.push(cloneMesh);
                    this.shadowGenerator.addShadowCaster(cloneMesh);
                    container.childName = e.parentName;
                    container.addChild(cloneMesh);
                    container.name = e.parentName;
                    container.position = new Babylon.Vector3(e.position.x, e.position.y, e.position.z);
                    if(e.groupParent.length > 0){
                        container.position.x = container.position.x + e.groupParent[0].position.x;
                        container.position.y = container.position.y + e.groupParent[0].position.y;
                        container.position.z = container.position.z + e.groupParent[0].position.z;
                        
                        }
                    container.rotationQuaternion = Babylon.Quaternion.RotationYawPitchRoll(e.rotation.y, e.rotation.x, e.rotation.z);
                    container.scaling = new Babylon.Vector3(e.scaling.x * -1, e.scaling.y, e.scaling.z);
                    //建立觸發器
                    // const radius = 5;
                    // const toggleArea = Babylon.MeshBuilder.CreateDisc("toggleArea_" + e.parentName, { radius: radius }, this.scene);
                    // toggleArea.rotation.x = Math.PI / 2;
                    // toggleArea.scaling.x = e.scaling.x;
                    // toggleArea.scaling.z = e.scaling.z;
                    // toggleArea.position.y = 0.5
                    // toggleArea.visibility = 0.1;
                    // toggleArea.parent = container;
                    // this.toggleList.push("toggleArea_" + e.parentName);
                    this.loadedAssets++;
                }
                
            })

        },

        async setLightAndShadows(){
            
            let hLight = new Babylon.HemisphericLight('hLight', new Babylon.Vector3(1,1,1), this.scene);
            hLight.intensity = 1;
            let light = new Babylon.DirectionalLight("light", new Babylon.Vector3(0, -2, 0), this.scene);
            light.intensity = 2;
            light.position = new Babylon.Vector3(0, 50, 0);

            this.shadowGenerator = new Babylon.ShadowGenerator(1024, light);
            this.shadowGenerator.useBlurExponentialShadowMap = false;
            this.shadowGenerator.useKernelBlur = false;
            this.shadowGenerator.blurKernel = 64;
            this.shadowGenerator.usePoissonSampling = false;
            this.shadowGenerator.getShadowMap().refreshRate = 5;
            
        },
        
        async loadPlayground(){
            console.log('loadPlayground');
            var darkgray = new Babylon.StandardMaterial("darkgray", this.scene);
            darkgray.diffuseColor = new Babylon.Color3(0.1, 0.1, 0.1);
            darkgray.specularColor = new Babylon.Color3(1, 1, 1);
            darkgray.Ambient =  new Babylon.Color3(0.1, 0.1, 0.1);
            var ground = Babylon.MeshBuilder.CreateGround(
                "ground",
                { width: 100, height: 100 },
                this.scene
            );
            ground.isVisible = this.showGround;
            ground.ambientColor = new Babylon.Color3(0.5, 0.5, 0.5);
            ground.material = darkgray;		
            ground.scaling.x = this.groundScale;
            ground.scaling.z = this.groundScale;
            this.shadowGenerator.addShadowCaster(ground);
            //設定重力
            ground.physicsImpostor = new Babylon.PhysicsImpostor(ground, 
                Babylon.PhysicsImpostor.BoxImpostor, { mass: 0, friction: 1, restitution: 0 }, this.scene
            );
            this.ground = ground;

        },
        //設定環境
        async setEnvMap(env){
            new Babylon.PhotoDome("hdrSkyBox", `/static/models/scene/${env}/${env}.jpg`,{
                resolution: 32,
                size: 1000
            },this.scene);
        },
        makePhysicsObject(newMeshes, scene, scaling){
  
            let physicsRoot = Babylon.Mesh.CreateBox("physicsRoot", 6, this.scene);
            physicsRoot.isVisible = false;
            physicsRoot.setPivotPoint(new Babylon.Vector3(0, 0, 0));
            
            newMeshes.forEach((m, i)=>{
                physicsRoot.addChild(m)
            })
            
            // Make every collider into a physics impostor
            physicsRoot.getChildMeshes().forEach((m,i)=>{
                m.scaling.x = Math.abs(m.scaling.x)
                m.scaling.y = Math.abs(m.scaling.y)
                m.scaling.z = Math.abs(m.scaling.z)
                
                m.rotationQuaternion = null
                m.position.y = -2
                m.rotation.z = 0;
     
               
            })
            physicsRoot.scaling.scaleInPlace(scaling)

            console.log(physicsRoot);
            return physicsRoot
        },
        clearRotationQuaternion(mesh) {
            if (mesh.rotationQuaternion) {
                // 先把當前世界旋轉記錄下來
                const worldMatrix = mesh.getWorldMatrix();
                const worldRotation = Babylon.Quaternion.FromRotationMatrix(worldMatrix.getRotationMatrix());
                mesh.rotationQuaternion = null;
                mesh.rotation = worldRotation.toEulerAngles();
            }
            if (mesh.getChildMeshes) {
                mesh.getChildMeshes().forEach(child => clearRotationQuaternion(child));
            }
        },

        
        async setCharacter(){
            console.log("setCharacter");
            const locationParam = this.$route.query.location;
            let customLocationX = 0;
            let customLocationY = 0;
            let customLocationZ = 0;
            if (locationParam) {
                const customLocation = locationParam.split(',').map(Number);
                customLocationX = customLocation[0];
                customLocationY = customLocation[1] -5;
                customLocationZ = customLocation[2];
            }
            console.log([customLocationX,customLocationY,customLocationZ]);
            
            
            let modelUrl = '0505modle_02_Adjust_lock.glb'
            if(this.isGameMode && this.selfRankingData > this.levelLimit){
                modelUrl = '0505modle_02_Adjust.glb'
            }else{
                modelUrl = '0505modle_02_Adjust_lock.glb'
            }
            const complexModel = (await Babylon.SceneLoader.ImportMeshAsync('', 'static/models/', modelUrl, this.scene));
            // 載入配件模型
            const accessoryModel = (await Babylon.SceneLoader.ImportMeshAsync('', 'static/models/', '0407modle_Mic_02.glb', this.scene)).meshes;

            var materialSphere = new Babylon.StandardMaterial("texture1", scene);
            materialSphere.diffuseColor = Babylon.Color3.Red();

            console.log('te',complexModel);
            // const targetBone = complexModel[0];
            const skeletons = complexModel.skeletons;
            const targetSkeleton = skeletons.find(bone => bone.name === "Armature_Modle");
            console.log("skeleton",targetSkeleton);

            // 找到目標骨骼（例如：右手骨骼）
            const targetBone = targetSkeleton.bones.find(bone => bone.name === "hand.R.002")

            accessoryModel[0].attachToBone(targetBone, complexModel.meshes[0]);
            accessoryModel[0].position = new Babylon.Vector3(0, 0, 0);
            accessoryModel[0].rotation = new Babylon.Vector3(0, 0, 0);

            console.log('create ellipse');
            // Convert to physics object and position
            var physicsRoot = this.makePhysicsObject(complexModel.meshes, this.scene, 0.2)
            const cameraLockMesh = new Babylon.Mesh("cameraLock", this.scene);
            cameraLockMesh.position.y = 10;
            cameraLockMesh.parent = physicsRoot;
            //this.character = complexModel[0];
            //physicsRoot.setPivotPoint(new Babylon.Vector3(0, 0, 0));
            //physicsRoot.physicsImpostor = new Babylon.PhysicsImpostor(physicsRoot, Babylon.PhysicsImpostor.MeshImpostor, { mass: 1, friction: 0, restitution: 0 }, this.scene);
            //physicsRoot.setPivotPoint(new Babylon.Vector3(0, -2.05, 0));
            //physicsRoot.position = new Babylon.Vector3(0, 2.05, 0);
            
            physicsRoot.physicsImpostor = new Babylon.PhysicsImpostor(physicsRoot, Babylon.PhysicsImpostor.BoxImpostor, { mass: 2  }, this.scene);

            this.character = physicsRoot;
            
            //this.character.physicsImpostor = new Babylon.PhysicsImpostor(this.character, Babylon.PhysicsImpostor.MeshImpostor, { mass: 1,  }, this.scene);

            this.camera.lockedTarget = cameraLockMesh;
            //this.camera.target = this.cameraLocker;
            
            this.character.position = new Babylon.Vector3(customLocationX,customLocationY,customLocationZ);
            this.character.actionManager = new Babylon.ActionManager(this.scene);
            
            this.scene.onBeforeRenderObservable.add(() => {
                const moveSpeed = 0.1;
                const rotateSpeed = 0.02;
                const rotateRatio = !this.invertRotation ? 0.4 : 0.4;
  
                if (this.keyInputs["w"]) {
                    this.characterDestination.distance = 0;
                    this.character.translate(Babylon.Axis.Z, moveSpeed + 0.2, Babylon.Space.LOCAL);

                }
                if (this.keyInputs["s"]) {
                    this.characterDestination.distance = 0;
                    this.character.translate(Babylon.Axis.Z, -moveSpeed - 0.2 , Babylon.Space.LOCAL);
                }
                if (this.keyInputs["a"]) {
                    this.characterDestination.distance = 0;
                    this.character.moveWithCollisions(this.camera.getDirection(new Babylon.Vector3( -moveSpeed, 0, 0)));

                }
                if (this.keyInputs["d"]) {
                    this.characterDestination.distance = 0;
                    this.character.moveWithCollisions(this.camera.getDirection(new Babylon.Vector3(moveSpeed, 0, 0)));
                    //console.log(this.character);
                }
                if (this.keyInputs["q"] || this.keyInputs["ArrowLeft"]) {
                    this.characterDestination.distance = 0;
                    this.character.rotate(Babylon.Vector3.Up(), -rotateSpeed);
                    this.camera.alpha -= 0.05 * (this.invertRotation ? rotateRatio : -rotateRatio);
                    //this.camera.alpha += 0.03;
                }
                if (this.keyInputs["e"] || this.keyInputs["ArrowRight"]) {
                    this.characterDestination.distance = 0;
                    this.character.rotate(Babylon.Vector3.Up(), +rotateSpeed);
                    this.camera.alpha += 0.05 * (this.invertRotation ? rotateRatio : -rotateRatio);
                }
                if (this.keyInputs["["] || this.keyInputs["ArrowUp"]) {
                    this.camera.beta -= this.camera.beta > 0.7 ? 0.05 : 0;
                }
                if (this.keyInputs["]"] || this.keyInputs["ArrowDown"]) {
                    this.camera.beta += this.camera.beta < 1.3 ? 0.05 : 0;
                }
            });
        },

        async interactWithMesh(mesh){
            if(!mesh) return;
            const name = mesh.name;
            if(name.includes('Monitor')|| name.includes('Screen') || name.includes('Board')|| name.includes('Display') && mesh.website){
                //this.tvToggle = true;
                if(mesh.website.includes(".mp4")){
                    this.tvToggle = true;
                    this.tvUrl = mesh.website;
                    //this.createYouTubePlayer();
                   
                }else if (mesh.website.includes("youtube") || mesh.website.includes("youtu.be")) {
                    if (!this.getId(mesh.website)) {
                        this.$message({ showClose: true, message: 'YouTube 連結格式錯誤，無法播放', type: 'error' });
                        return;
                    }
                    this.tvToggle = true;
                    this.tvUrl = 'https://www.youtube.com/embed/'+this.getId(mesh.website)+'?modestbranding=1&autohide=1&showinfo=0';
                    //this.createYouTubePlayer();
                }
                else{
                    this.attachedWebsite = mesh.website;
                    this.attachedBoardImg = mesh.boardImg;
                    this.boardToggle = true;
                }


            }
            if(name.includes('lowpoly') && mesh.url || (mesh.type==='Customized') && mesh.url){
                this.popUpCanvasToggle = true;
                this.initPopUpScene({
                    url: '',
                    fileName: mesh.url,
                    modelName: mesh.modelName||'Unnamed',
                })
            }
            if(name.includes('Counter')||name.includes('Info')||name.includes('info')){
                this.toggleForm();
            }
            if(name.includes('Form')||name.includes('form')){
                const userId = localStorage.getItem('userId')
                //檢查是否已經答過題
                await getFormResult(userId).then(res=>{
                    if(res.data.data.length > 0){
                        const answered = JSON.parse(res.data.data[0].content);
                        this.quizAnswers = answered; // 將已作答內容放入 quizAnswers
                        this.formIsAnswered = true;  // 標記為已作答
                    }
                })
                this.formToggle = true;
                
            }
        },

        confirmLogout(){
            if(this.login){
                this.setLogout();
                this.$message({
                    showClose: true,
                    message: `Logout`,
                    type: 'success',
                    duration: 1500,
                    onClose:()=>{
                        this.$store.dispatch('loader/show');
                        this.$router.push("/landing");
                    }
                });
            }
        },
        async taggleEvent(){
            console.log("taggleEvent");
            let mesh = this.meshData;
            mesh.forEach((e,index)=>{ 
                if(e.type=='notGeo' && e.modelType === 'Teleport' ){
                    this.teleportTypeName.push("tel_"+index);
                    var box = Babylon.Mesh.CreateBox("tel_"+index, 2, this.scene);
                    box.material = new Babylon.StandardMaterial("Mat", this.scene);
                    box.position = new Babylon.Vector3(5, 0, -5);
                    box.position.y = e.position.y;
                    box.position.x = e.position.x;
                    box.position.z = e.position.z;
                    box.rotation.y = e.rotation.y;
                    box.rotation.x = e.rotation.x;
                    box.rotation.z = e.rotation.z;
                    box.scaling.y = e.scaling.y;
                    box.scaling.x = e.scaling.x*-1;
                    box.scaling.z = e.scaling.z;
                    box.sendLink = e.sendLink;
                    box.sendLocation = e.sendLocation;
                    box.isVisible = false;
                }else if(e.type=='notGeo' && e.modelType === 'Collision' ){
                    this.collisionTypeName.push("col_"+index);
                    var box = Babylon.Mesh.CreateBox("col_"+index, 2, this.scene);
                
                    box.isVisible = false;
                    box.position.y = e.position.y;
                    box.position.x = e.position.x;
                    box.position.z = e.position.z;
                    box.rotation.y = e.rotation.y;
                    box.rotation.x = e.rotation.x;
                    box.rotation.z = e.rotation.z;
                    box.scaling.y = e.scaling.y;
                    box.scaling.x = e.scaling.x*-1;
                    box.scaling.z = e.scaling.z;
                    box.collisionScoreLimit = e.collisionScoreLimit;
                    // box.physicsImpostor = new Babylon.PhysicsImpostor(box, Babylon.PhysicsImpostor.BoxImpostor, { mass: 0, friction: 1, restitution: 0 }, this.scene)
                }
            });

            //this.character.actionManager = new Babylon.ActionManager(this.scene);
            //處理傳送
            this.teleportTypeName.forEach(element => {
                let targetMesh_geo = this.scene.getMeshByName(element)

                let action = new Babylon.ExecuteCodeAction(
                    {
                        trigger: Babylon.ActionManager.OnIntersectionEnterTrigger, 
                        parameter: targetMesh_geo,
                    },
                    (evt) => {
                        let toggleMesh = evt.additionalData;
                        let sendLink = toggleMesh.sendLink;
                        let sendLocation = toggleMesh.sendLocation;                        
                        let moveToUrl = `${sendLink}&location=${sendLocation}`;
                        window.location.replace(moveToUrl);
                    }
                );

                this.character.actionManager.registerAction(action);
                console.log(this.character);
            });
            
            // 感應區域
            this.collisionTypeName.forEach(element => {
                let targetMesh_geo = this.scene.getMeshByName(element)
                targetMesh_geo.physicsImpostor = new Babylon.PhysicsImpostor(targetMesh_geo, Babylon.PhysicsImpostor.BoxImpostor, { mass: 0 }, this.scene)

                targetMesh_geo.physicsImpostor.registerOnPhysicsCollide(this.character.physicsImpostor, function(main, collided) {
                    main.setLinearVelocity(Babylon.Vector3.Zero());
                    main.setAngularVelocity(Babylon.Vector3.Zero());

                });
            });
            
            //註冊可觸發物件範圍
            this.toggleList.forEach(key => {
                let targetMesh = this.scene.getMeshByName(key);
                let toggleOnAction = new Babylon.ExecuteCodeAction(
                    {
                        trigger: Babylon.ActionManager.OnIntersectionEnterTrigger,
                        parameter: targetMesh,
                    },
                    (evt) => {
                        console.log('toggle on!');
                        const parentMesh = targetMesh.parent;
                        const childMesh = parentMesh.getChildMeshes();
                        childMesh.forEach(e=>{
                            e.renderOutline = true;
                            e.outlineColor = new Babylon.Color3(0, 1, 0);
                            e.outlineWidth = 0.05;
                        })
                        this.attachedWebsite = childMesh[0].website;
                        this.attachedBoardImg = childMesh[0].boardImg;
                        this.boardToggle = true;
                    }
                );
                let toggleOffAction = new Babylon.ExecuteCodeAction(
                    {
                        trigger: Babylon.ActionManager.OnIntersectionExitTrigger,
                        parameter: targetMesh,
                    },
                    (evt) => {
                        console.log('toggle off!');
                        const parentMesh = targetMesh.parent;
                        const childMesh = parentMesh.getChildMeshes();
                        childMesh.forEach(e=>{
                            e.renderOutline = false;
                        })
                    }
                );
                this.character.actionManager.registerAction(toggleOnAction);
                this.character.actionManager.registerAction(toggleOffAction);
            });

            //碰撞
            this.collisionTypeName.forEach(element => {
                let targetMesh_geo = this.scene.getMeshByName(element)
                console.log('targetMesh_geo',targetMesh_geo);
                
                // 檢查 collisionScoreLimit 是否為空字串
                if (targetMesh_geo.collisionScoreLimit === '') {
                    // 如果是空字串，直接添加物理碰撞，不進行分數檢查
                    targetMesh_geo.physicsImpostor = new Babylon.PhysicsImpostor(targetMesh_geo, Babylon.PhysicsImpostor.BoxImpostor, { mass: 0 }, this.scene)
                    
                    targetMesh_geo.physicsImpostor.registerOnPhysicsCollide(this.character.physicsImpostor, function(main, collided) {
                        main.setLinearVelocity(Babylon.Vector3.Zero());
                        main.setAngularVelocity(Babylon.Vector3.Zero());
                    });
                } else if (this.selfRankingData <= targetMesh_geo.collisionScoreLimit) {
                    // 如果不是空字串，且有分數限制，則進行分數檢查
                    targetMesh_geo.physicsImpostor = new Babylon.PhysicsImpostor(targetMesh_geo, Babylon.PhysicsImpostor.BoxImpostor, { mass: 0 }, this.scene)
                    
                    // 創建 GUI 面板
                    let advancedTexture = BabylonGUI.AdvancedDynamicTexture.CreateFullscreenUI("UI");
                    let messagePanel = new BabylonGUI.Rectangle("messagePanel");
                    messagePanel.width = "500px";
                    messagePanel.height = "100px";
                    messagePanel.cornerRadius = 10;
                    messagePanel.color = "white";
                    messagePanel.thickness = 2;
                    messagePanel.background = "rgba(0, 0, 0, 0.8)";
                    messagePanel.isVisible = false;
                    advancedTexture.addControl(messagePanel);

                    let messageText = new BabylonGUI.TextBlock();
                    messageText.text = "你的學習積分不夠，需要達到"+targetMesh_geo.collisionScoreLimit+"分";
                    messageText.color = "white";
                    messageText.fontSize = 24;
                    messagePanel.addControl(messageText);
                    
                    targetMesh_geo.physicsImpostor.registerOnPhysicsCollide(this.character.physicsImpostor, function(main, collided) {
                        main.setLinearVelocity(Babylon.Vector3.Zero());
                        main.setAngularVelocity(Babylon.Vector3.Zero());
                        
                        // 顯示訊息面板
                        messagePanel.isVisible = true;
                        
                        // 1.5秒後隱藏訊息面板
                        setTimeout(() => {
                            messagePanel.isVisible = false;
                        }, 1500);
                    });
                } else {
                    // 如果分數大於限制，移除物理碰撞
                    if (targetMesh_geo.physicsImpostor) {
                        targetMesh_geo.physicsImpostor.dispose();
                        targetMesh_geo.physicsImpostor = null;
                    }
                }
            });
    
        },
        //  介面操作
        closePopScene(){
            this.loading = false;
            this.popUpCanvasToggle = false;
            this.engine.runRenderLoop(()=>{
                this.scene.render();
                this.engine.resize();
            });
            this.popEngine.stopRenderLoop();
            this.popEngine.dispose();
            setTimeout(()=>{
                this.loading = false;
            }, 750);
        },
        switchMenuState(state, toggleBehavior=true){
            this.extendMenu = false;
            if(this.menuState===state&&this.menuToggle&&toggleBehavior){
                this.menuToggle = false;
                return;
            }
            switch (state) {
                case this.MENU_STATE.BLOCK:
                    break;
                case this.MENU_STATE.CHAT:
                    break;
                case this.MENU_STATE.CONTACT:
                    break;
                case this.MENU_STATE.PLAYER_ID:
                    break;
            }
            this.menuState = state;
            this.menuToggle = true;
        },
        shotPhoto(){
            this.extendMenu = false;
            Babylon.Tools.CreateScreenshot(engine, camera, { width: window.innerWidth, height: window.innerHeight }, function (data) {
                this.screenShotSrc = data;
            });
        },
        //還要研究
        initPopUpScene(data){
            this.engine.stopRenderLoop();//stop main scene rendering;
            let canvas = document.getElementById('pop-up-canvas');
            this.popEngine = new Babylon.Engine(canvas, true);
            let scene = new Babylon.Scene(this.popEngine);
            scene.name = 'PopScene';
            window.scenes = scene;

            let camera = new Babylon.ArcRotateCamera('arcCameraPop', 0, 0, 7, new Babylon.Vector3(0,0,0), scene);
            camera.attachControl(canvas, true);
            camera.lowerRadiusLimit = 2;
            camera.beta = Math.PI/3;
            camera.alpha = Math.PI/2;
            camera.upperRadiusLimit = 15;
            camera.wheelDeltaPercentage = 0.01;

            let pixelRatio = window.devicePixelRatio;
            // Set the render engine to scale properly
            engine.setHardwareScalingLevel(1 / pixelRatio); // This makes the scene and GUI clear on a HDPI display, but its no longer the correct size.

            let light = new Babylon.HemisphericLight('',new Babylon.Vector3.Zero(), scene);
            light.intensity = 1.2;

            let helper = scene.createDefaultEnvironment({
                groundShadowLevel: 0,
                groundColor: new Babylon.Color3.FromHexString('#fff'),
                skyboxColor: new Babylon.Color3.FromHexString('#fff'),
                skyboxSize: 50,   
            });
            Babylon.SceneLoader.ImportMesh('', data.url, data.fileName, scene, (container)=>{
                let rootMesh = container.filter(e=>e.name==='__root__')[0];
                rootMesh.setPivotPoint(new Babylon.Vector3.Zero());
                rootMesh.position.set(0,0,0);
                container.forEach(e=>{
                    if(e.name.includes('lowpoly')){
                        e.setEnabled(false);
                    }
                })
                //scene.stopAllAnimations();
            },(prog)=>{
                console.log(prog);
            },(error)=>{
                console.log(error);
            })
            this.popEngine.runRenderLoop(()=>{
                scene.render();
                this.popEngine.resize();
            })
            scene.onPointerPick = (event, pickResult)=>{
                if(!pickResult.hit) return;
                let name = pickResult.pickedMesh.name;
                // let anim = null;
                if(name.includes('dot')){
                    let anim = scene.getAnimationGroupByName((name.split('_')[0]).replace('txt','Anim'));
                    if(anim && !anim.isPlaying){//Avoid animation playing while clicking trigger;
                        if(anim.playback){
                            anim.start(false, 1, anim.to, anim.from, true);
                        }else{
                            anim.start(false, 1, anim.from, anim.to, true);
                        }
                        anim.onAnimationEndObservable.addOnce(()=>{
                            anim.stop();
                        })
                        anim.playback = anim.playback ? false:true;
                    }
                    /* 動畫聚焦 */
                    // this.animateCameraToPosition(camera, 1, 1.8, pickResult.pickedPoint);
                    // anim.onAnimationEndObservable.addOnce(()=>{
                    //     ele.goToFrame(ele.to);
                    //     ele.playback = anim.playback?false:true;
                    // });
                }
            }
        },
        getId(url) {
            if(!url || url===undefined) return;
            let regExp = /^.*(youtu.be\/|v\/|u\/\w\/|embed\/|shorts\/|live\/|watch\?v=|&v=)([^#&?]*).*/;
            let match = url.match(regExp);

            return (match && match[2].length === 11) ? match[2] : null;
        },
        clearUI(){
            this.popUpCanvasToggle = this.tvToggle = this.introToggle = this.popUpCanvasToggle = this.formToggle = this.boardToggle = false;
        },
        async sendMessage(){
            this.clearUI();
            const vm = this;
            vm.getUserData();
            await sendMail(this.form, this.$route.query.id).then((res)=>{
                vm.showMessage = this.MESSAGE_STATE.SUCCESS;
                setTimeout(()=>{
                    vm.showMessage = 0;
                }, 1500)
            }).catch(err=>{
                vm.showMessage = this.MESSAGE_STATE.FAIL;
                setTimeout(()=>{
                    vm.showMessage = 0;
                }, 1500)
            })
        },
        keydownEvent(e){
            if(e.keyCode===13){
                if(!this.chatMessage.length) return;
                this.sendChatMessage();
            }
        },
        sendChatMessage(){
            this.updateChatMessage({
                name: this.nickname,
                messages: this.chatMessage,
                room: this.$route.query.id
                //theme: this.currentTheme,
            });
        },
        backToEntrance(){
            this.$router.push({name: 'Entrance'});
        },
        setPlayerID(){
            localStorage.setItem('playerID', this.playerID);
        },
        onPlayerStateChange(event) {
            console.log('onPlayerStateChange',event);
            if (event.data === YT.PlayerState.PLAYING) {
                this.viewStartTime = Date.now();
                console.log('viewStartTime',this.viewStartTime);
            // 啟動追蹤積分
            } else if (event.data === YT.PlayerState.PAUSED || event.data === YT.PlayerState.ENDED) {
                const elapsedSec = (Date.now() - this.viewStartTime) / 1000;
                console.log('elapsedSec',elapsedSec);
            // 記錄或送到後端
            }
        },
        initYouTubeAPI() {
            // 確保全局只加載一次 YouTube API
            if (!window.YT) {
                const tag = document.createElement('script');
                tag.src = "https://www.youtube.com/iframe_api";
                const firstScriptTag = document.getElementsByTagName('script')[0];
                firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
            }
            console.log('initYouTubeAPI');
            // 設置全局回調
            window.onYouTubeIframeAPIReady = () => {
                console.log('onYouTubeIframeAPIReady');
                this.createYouTubePlayer();
            };
        },
        createYouTubePlayer() {
            
    
            console.log('createYouTubePlayer');

            // 從 URL 中獲取影片 ID
            const videoId = this.getId(this.tvUrl);
            console.log('videoId',videoId);
            if (!videoId) return; // mp4 等非 YouTube 影片不建播放器

            // YouTube API 還沒載入：第一次播放時才載入，載好後再呼叫一次
            if (!window.YT || !window.YT.Player) {
                window.onYouTubeIframeAPIReady = () => this.createYouTubePlayer();
                if (!document.querySelector('script[src*="youtube.com/iframe_api"]')) {
                    const tag = document.createElement('script');
                    tag.src = 'https://www.youtube.com/iframe_api';
                    tag.onerror = () => this.$message({ showClose: true, message: 'YouTube 播放器載入失敗，請檢查網路', type: 'error' });
                    document.head.appendChild(tag);
                }
                return;
            }

            this.player = new YT.Player('tv-screen', {
                videoId: videoId,
                height: '100%',
                width: '100%',
                events: {
                    onReady: this.onPlayerReady,
                    onStateChange: this.onPlayerStateChange,
                    // 影片不存在、私人、禁止嵌入等
                    onError: (e) => this.$message({ showClose: true, message: `YouTube 影片無法播放（錯誤碼 ${e.data}），可能已刪除、設為私人或禁止嵌入`, type: 'error' })
                },
                playerVars: {
                    autoplay: 1,
                    controls: 1,
                    modestbranding: 1,
                    rel: 0
                }
            });
            console.log('player',this.player);
        },
        onPlayerReady(event) {
            console.log('播放器已準備就緒');
            event.target.playVideo();
        },
        onPlayerStateChange(event) {
            console.log('播放狀態改變:', event.data);
            switch(event.data) {
                case YT.PlayerState.PLAYING:
                    this.viewStartTime = Date.now();
                    console.log('開始播放時間:', this.viewStartTime);
                    break;
                
                case YT.PlayerState.PAUSED:
                    const elapsedTime = (Date.now() - this.viewStartTime) / 1000;
                    console.log('暫停播放，已播放秒數:', elapsedTime);
                    break;
                
                case YT.PlayerState.ENDED:
                    const totalTime = (Date.now() - this.viewStartTime) / 1000;
                    console.log('播放結束，總播放秒數:', totalTime);
                    break;
            }
        },
        closeTvPlayer() {
            if (this.player) {
                try {
                    this.player.stopVideo();
                    this.player.destroy();
                } catch (error) {
                    console.error('停止播放時出錯:', error);
                }
                this.player = null;
            }
            this.tvToggle = false;
            this.tvUrl = ''; // 清掉，下次點同一支影片 watcher 才會再觸發
        },
        async getRankingData(){
            const userId = localStorage.getItem('userId')
            this.rankingToggle = true;
            const response = await getRanking();
            const selfResponse = await getSelfRanking(userId);
            
            this.rankingData = response.data.data.list;
            this.selfRankingData = selfResponse.data.data;
            this.rankingData.sort((a, b) => b.score - a.score);
            this.checkUserLevelUp = false;

            // 檢查 localStorage 是否已記錄使用者點擊過升級
            const hasLeveledUp = localStorage.getItem('userHasLeveledUp');
            console.log('hasLeveledUp',hasLeveledUp);
            if (!hasLeveledUp && this.selfRankingData > this.levelLimit ){
                this.oldSelfRankingData = this.selfRankingData;
                this.checkUserLevelUp = true;
            }else{
                this.oldSelfRankingData = this.selfRankingData;
                 if (hasLeveledUp) {
                    this.checkUserLevelUp = false; // 如果已經點擊過，則不顯示
                }
            }

            // 找到使用者在排行榜中的名次
            const selfRankingIndex = this.rankingData.findIndex(item => item.userId === userId);
            const selfRanking = selfRankingIndex + 1; // 因為索引從0開始，所以要+1
            this.selfRanking = selfRanking;

            const checkUserConfirm = localStorage.getItem('checkUserConfirm');
            if(checkUserConfirm){
                this.checkUserConfirm = true;
            }else{
                this.checkUserConfirm = false;
            }

            console.log('oldSelfRankingData',this.oldSelfRankingData);
            console.log('checkUserLevelUp',this.checkUserLevelUp);
            console.log('rankingData',this.rankingData);
            console.log('selfRankingData',this.selfRankingData);
        },
        levelUp(){
            console.log('levelUp');
            // 設定 localStorage 標記，表示使用者已點擊升級
            localStorage.setItem('userHasLeveledUp', 'true');
            this.checkUserLevelUp = false; // 更新狀態，避免再次顯示
            window.location.reload();
        },
        async trackEvent(eventType, duration , content = '') { // 新增 trackEvent 方法
            if(!this.isGameMode) return;
            console.log('追蹤',eventType, duration);
            try {
                const body = {
                    event: eventType,
                    content: content,
                    duration: duration
                };
                const response = await sendEvent(body); // 假設 sendEvent 接受一個 body 物件
            } catch (error) {
                console.error('呼叫 sendEvent 失敗:', error);
                // 可以在這裡加入失敗提示
            }
        },
        async submitQuiz() {
            console.log('提交的答案:', this.quizAnswers);
            
            // 檢查是否所有題目都已作答
            const unansweredQuestions = this.quizData.filter((_, index) => !this.quizAnswers[index]);
            
            if (unansweredQuestions.length > 0) {
                this.$message({
                    message: `還有 ${unansweredQuestions.length} 題未作答，請完成所有題目後再提交！`,
                    type: 'warning',
                    duration: 3000
                });
                return;
            }
            
            let correctCount = 0;
            let totalQuestions = this.quizData.length;
            let wrongAnswers = [];
            
            // 檢查每個答案
            this.quizData.forEach((question, index) => {
                const userAnswer = this.quizAnswers[index];
                const correctAnswer = question.answer;
                
                if (userAnswer === correctAnswer) {
                    correctCount++;
                } else {
                    wrongAnswers.push({
                        questionId: question.id,
                        userAnswer: userAnswer,
                        correctAnswer: correctAnswer
                    });
                }
            });

            // 計算分數（百分比）
            const score = (correctCount / totalQuestions) * 100;
            
            console.log('測驗結果:', {
                totalQuestions,
                correctCount,
                score: score,
                wrongAnswers
            });

            const result = {
                exhibitionId: this.$route.query.id,
                content: JSON.stringify(this.quizAnswers),
                score: score
            };
            const response = await sendFormResult(result);  // 這裡需要實作 sendQuizResult API
            console.log('response',response);

            // 顯示結果給使用者
            this.$message({
                message: `測驗完成！得分：${score.toFixed(2)}%（${correctCount}/${totalQuestions}題正確）`,
                type: score >= 60 ? 'success' : 'warning',
                duration: 5000
            });

            this.formToggle = false; // 提交後關閉問卷
        },
        initMessageListener() {
            console.log('initMessageListener');
            console.log('isGameMode');
                window.addEventListener('message', (event) => {
                    console.log('message',event);
                    const data = event.data;
                    if (typeof data === 'object' && data.type && data.type.startsWith('video-')) {
                    switch (data.type) {
                        case 'video-play':
                            
                            break;
                        case 'video-pause':
                            console.log('video-pause',data);
                            
                            break;
                        case 'video-ended':
                            
                            break;
                        case 'video-seeked':
                            // 若有 currentTime 可同步
                            if (typeof data.currentTime === 'number') {
                                this.videoCurrentTime = data.currentTime;
                            }
                            break;
                    }
                }
                if (data && data.type === 'watched-time-progress') {
                    console.log(`當前看到第 ${data.currentSecond} 秒，累積已看 ${data.totalWatchedSeconds} 秒`);
                }
                if (data && data.type === 'watched-time-report') {
                    console.log(`累積已看 ${data.totalWatchedSeconds} 秒, 影片ID: ${data.videoId}`);
                    this.trackEvent('video_view', data.totalWatchedSeconds , data.videoId)
                }
                //每秒傳輸
                if (data?.type === 'image-watch-progress') {
                    
                }
                if (data?.type === 'image-watch-report') {
                    console.log(`[完成] ${data.imageId}: 共 ${data.seconds} 秒`);
                        this.trackEvent('photo_view', data.seconds, data.imageId)
                    }
                });
        },

        setupVideoWatchTimeTracker(video) {
            // 用 Set 來避免重複計算同一秒
            this.watchedSeconds = new Set();

            // 每秒偵測
            this.videoWatchInterval = setInterval(() => {
              if (!video.paused && !video.seeking) {
                const sec = Math.floor(video.currentTime);
                this.watchedSeconds.add(sec);
                // 你可以在這裡即時顯示
                // console.log('目前已觀看秒數:', this.watchedSeconds.size);
              }
            }, 1000);

            // 可隨時查詢累積「被看過的總秒數」
            this.getWatchedSeconds = () => this.watchedSeconds.size;
        },
        // 例如：頁面離開時上報
        reportWatchedTime() {
            const seconds = this.getWatchedSeconds ? this.getWatchedSeconds() : 0;
            console.log('累積觀看秒數:', seconds);
            // 這裡可以呼叫 API 或 postMessage
        }
    },
    watch:{
        loadedAssets(){
            console.log('loadedAssets',this.loadedAssets);
            // if(this.loadedAssets == this.meshData.length){
            //     this.taggleEvent();
            // }
        },
        tvUrl(newUrl) {
            if (newUrl && this.tvToggle) {
                this.createYouTubePlayer();
            }
        }
    },
    created(){
        console.log("ExhibitionNew created");
    },
    mounted(){
        
        this.init();
        this.initMessageListener(); // 這裡呼叫
        
        //this.initYouTubeAPI();
        
        // 取得 video 元素
        const video = this.$refs.myVideo;
        if (video) {
            this.setupVideoWatchTimeTracker(video);
        }
        // 頁面離開時自動上報
        window.addEventListener('beforeunload', this.reportWatchedTime);
    },
    computed:{
        ...mapGetters(["vendor"]),
        currentRoom(){
            return this.$route.query.room;
        },
        userId(){
            return localStorage.getItem("userId");
            // return this.$route.query.uid;
        },
        login(){
            const uid = localStorage.getItem('userId');
            const token = localStorage.getItem('token');
            if(uid&&token){
                return true;
            }
            else{
                return false;
            }
        },
        menuTitle(){
            if(this.menuState===this.MENU_STATE.INTRO){
                return "Block Intro";
            }
            else if(this.menuState===this.MENU_STATE.CONTACT){
                return "Contact";
            }
            else if(this.menuState===this.MENU_STATE.CHAT){
                return "Chat";
            }
            else if(this.menuState===this.MENU_STATE.ACCOUNT_INFO){
                return "Account Info";
            }
            else{
                return "";
            }
        },
        selfRankingIndex() {
            return this.rankingData.findIndex(item => item.userName === '自己') + 1;
        }
    },
    destroyed(){
        if(this.engine){
            this.engine.stopRenderLoop();
            this.engine.dispose();
        }
        if(this.popEngine){
            this.popEngine.stopRenderLoop();
            this.popEngine.dispose();
        }
        // 清理播放器實例
        if (this.player && this.player.destroy) {
            this.player.destroy();
        }
        window.removeEventListener('beforeunload', this.reportWatchedTime);
        if (this.videoWatchInterval) {
            clearInterval(this.videoWatchInterval);
        }
    },
}
</script>
